import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/* global m*/

import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import Icon from 'flarum/common/components/Icon';
import Separator from 'flarum/common/components/Separator';
import classList from 'flarum/common/utils/classList';
import Button from 'flarum/common/components/Button';
export default class LinkItem extends LinkButton {
  constructor() {
    super(...arguments);
    // Just definitions to satisfy TypeScript
    _defineProperty(this, "attrs", void 0);
  }
  view(vnode) {
    if (this.isLabel) return this.labelView(vnode);
    return this.linkView(vnode);
  }
  labelView(vnode) {
    const link = this.attrs.link;
    const LinkLabelNode = this.attrs.inDropdown ? 'span' : Button;
    return m('[', null, this.attrs.inDropdown && m(Separator, null), m(LinkLabelNode, {
      class: classList(this.class, 'LinksButton--label'),
      onclick: e => {
        if (this.attrs.inDropdown) {
          // don't close dropdown when clicking label
          e.stopPropagation();
        }
      },
      "data-toggle": this.attrs.isDropdownButton ? 'dropdown' : undefined
    }, this.icon, m("span", {
      className: "LinksButton-title"
    }, link.title())), this.attrs.inDropdown && m(Separator, null));
  }
  linkView(vnode) {
    const link = this.attrs.link;
    const linkAttrs = {
      className: this.class,
      rel: this.rel,
      target: this.linkTarget,
      external: link.isNewtab() ? false : !link.isInternal(),
      href: this.linkHref
    };
    return m(Link, linkAttrs, this.icon, m("span", {
      className: "LinksButton-title"
    }, link.title()));
  }
  get isInternal() {
    const link = this.attrs.link;
    return link.isInternal() && !link.isNewtab();
  }
  get isLabel() {
    return this.attrs.link.url().length === 0;
  }
  get linkHref() {
    const link = this.attrs.link;
    const url = link.url();
    if (url.startsWith('/') && link.isInternal()) {
      return app.forum.attribute('baseUrl') + url;
    }
    return url;
  }
  get icon() {
    const link = this.attrs.link;
    const iconClass = link.icon();
    if (iconClass) {
      return m(Icon, {
        name: iconClass,
        className: "Button-icon LinksButton-icon"
      });
    }
    return null;
  }
  get rel() {
    // Prevent security risk on older browsers.
    // Modern browsers now have `noopener` by default and
    // require `opener` to enable `window.opener`.
    //
    // Learn more:
    // https://web.dev/external-anchors-use-rel-noopener

    return classList(this.attrs.link.isNewtab() && 'noopener noreferrer', this.attrs.link.useRelMe() && 'me') || undefined;
  }
  get class() {
    return classList('LinksButton', 'Button Button--link', this.attrs.className, {
      'LinksButton--inDropdown': this.attrs.inDropdown,
      active: this.isLinkCurrentPage
    });
  }
  get isLinkCurrentPage() {
    const link = this.attrs.link;
    if (!link.isInternal()) return false;
    const base = app.forum.attribute('baseUrl');

    // Mithril returns the current path relative to the origin, which isn't necessarily the base forum URL
    const currentUrl = new URL(m.route.get() || '/', base);
    const currentPath = currentUrl.href.replace(base, '');

    // The link from `this.linkHref` should already be absolute, but we'll make sure
    const linkUrl = new URL(this.linkHref, base);
    const linkPath = linkUrl.href.replace(base, '');

    // For exact match or root path
    if (currentPath === linkPath) return true;
    if (linkPath === '/') return false;

    // The link is active if the current path starts with the link path followed by a path boundary
    // This prevents false matches like '/t' matching '/tags'
    return currentPath.startsWith(linkPath) && /^[/?#]/.test(currentPath.charAt(linkPath.length));
  }
  get linkTarget() {
    const link = this.attrs.link;
    if (this.isInternal) return undefined;
    return link.isNewtab() ? '_blank' : undefined;
  }
}
flarum.reg.add('fof-links', 'forum/components/LinkItem', LinkItem);